export default __webpack_public_path__ + "static/Persona-Simon-fc6f85485701008e636811236c13f353.png";